import store from "@/store";
import { NavBarHeight } from "@/const/common";
export const toPercent = (current = 0, last) => {
  if (!last && current) {
    return { value: "100%", rise: true };
  }
  if (last) {
    const m = ((current - last) / last) * 100;
    const value = Math.abs(m.toFixed(2)) + "%";
    const rise = m >= 0;
    return { value, rise };
  } else {
    return { value: "0%", rise: true };
  }
};
export const rounding = (num) => {
  // 化分为元
  if (!!num) {
    num = num + "";
    const len = num.length;
    if (len == 1) {
      num = "0.0" + num;
    } else if (len == 2) {
      num = "0." + num;
    } else {
      num = ((num - 0) / 100).toFixed(2);
    }
  } else {
    num = "0.00";
  }
  return num;
};
export const getYMDHMS = (timestamp, formatter = "yyyy-mm-dd hh-mm-ss") => {
  let time = new Date(Number(timestamp)),
    timeStr = "";
  let year = time.getFullYear();
  const month = (time.getMonth() + 1).toString().padStart(2, "0");
  const date = time.getDate().toString().padStart(2, "0");
  const hours = time.getHours().toString().padStart(2, "0");
  const minute = time.getMinutes().toString().padStart(2, "0");
  const second = time.getSeconds().toString().padStart(2, "0");

  switch (formatter) {
    case "yyyy-mm-dd hh-mm":
      timeStr = year + "." + month + "." + date + " " + hours + ":" + minute;
      break;
    case "yyyy-mm-dd":
      console.log("yyyy-mm-dd");
      timeStr = year + "." + month + "." + date;
      break;
    case "mm-dd":
      timeStr = month + "月" + date + "日";
      break;
    default:
      timeStr =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hours +
        ":" +
        minute +
        ":" +
        second;
  }
  return timeStr;
};
export function getNavHeight() {
  return store.getters.GetStatus + NavBarHeight;
}
export function isEmpty() {
  switch (typeof value) {
    case "undefined":
      return true;
    case "string":
      if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, "").length == 0)
        return true;
      break;
    case "boolean":
      if (!value) return true;
      break;
    case "number":
      if (0 === value || isNaN(value)) return true;
      break;
    case "object":
      if (null === value || value.length === 0) return true;
      for (var i in value) {
        if (value.hasOwnProperty(i)) {
          return false;
        }
      }
      return true;
  }
  return false;
}
export function formatCurrency(x, n = 2) {
  var f_x = parseFloat(x);
  if (isNaN(f_x)) {
    x = 0;
  }
  var f_x = Math.round(x * 100) / 100;
  var s_x = f_x.toString();
  var pos_decimal = s_x.indexOf(".");
  if (pos_decimal < 0) {
    pos_decimal = s_x.length;
    s_x += ".";
  }
  while (s_x.length <= pos_decimal + n) {
    s_x += "0";
  }
  return s_x;
}
export function debounce(fn, delay = 1000) {
  var timer = null; // 声明计时器
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}
